import { SelectList } from '@app/store/SelectList/SelectList';
import { EntityType } from '@app/store/SelectList/UtilityTypes';

export function defaultOrder<TStore extends keyof SelectList>(items: Array<EntityType<TStore>>): Array<EntityType<TStore>> {
	return items;
}
